;(function($, undefined){

    var rnn = window.rnn,
        log = rnn.logging.log;
    
    function removeCookie(name) {
        document.cookie = name +
        '=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/';
    }

    function getCookie(c_name) {
        var i, x, y, theCookies = document.cookie.split(";");

        for (i = 0; i < theCookies.length; i++) {
            x = theCookies[i].substr(0, theCookies[i].indexOf("="));
            y = theCookies[i].substr(theCookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g,"");

            if (x == c_name) {
                return unescape(y);
            }
        }
    }

    function genAudienceFromCookie(audienceType, ccaudsCookieObj){
        var audiences;

        audiences = (audienceType) ? ccaudsCookieObj.Profile.Audiences.ThirdPartyAudience : ccaudsCookieObj.Profile.Audiences.Audience;

        return audiences;
    }

    function genLotameAudiences(audienceType){
        var IDs = "";

        var cookieName = 'ccaudsString_' + _currLotameID,
            ccaudsCookieString = getCookie(cookieName) || '',
            ccaudsCookieObj,
            settingWithCookie;

        if(ccaudsCookieString.length > 0){
            ccaudsCookieObj = $.parseJSON(ccaudsCookieString);
        }

        if(ccaudsCookieString.length > 0 || typeof ccauds !== 'undefined'){
            var audiences;

            if (typeof ccauds !== 'undefined'){
                // check from object first
                audiences = (audienceType) ? ccauds.Profile.Audiences.ThirdPartyAudience : ccauds.Profile.Audiences.Audience;

                // even if the object is loaded, the audiences could be empty. 
                // check to see if it is empty. if it is, use the cookie instead.
                if(typeof audiences === 'undefined' || audiences.length === 0){
                    if(typeof ccaudsCookieObj !== 'undefined'){
                        audiences = genAudienceFromCookie(audienceType, ccaudsCookieObj);
                        log('[lotame] no IDs in object. Falling back to cookie');
                    }
                }else{
                    log('[lotame] using ccauds object');
                }
            }else{
                // fallback to cookie
                audiences = genAudienceFromCookie(audienceType, ccaudsCookieObj);
                settingWithCookie = true;
                log('[lotame] ccauds object not returned before module fire. using stored cookie');
            }            

            if(typeof audiences === 'undefined' || audiences.length === 0){
                if(!audienceType && settingWithCookie){
                    removeCookie(cookieName);
                } else if(!audienceType){
                    log('[lotame] no IDs in object returned and no cookie generated as of module fire');
                }else if(audienceType){
                    log('[lotame] no third party IDs to return');
                }
                return '';
            }else{
                for(var i = 0; i < audiences.length; i++){
                    IDs += audiences[i].id;
                    if(i !== audiences.length - 1){
                        IDs += ",";
                    }
                }
                log('[lotame] IDs returned');
                return IDs;
            }            
        }else{
            log('[lotame] ccauds not yet returned, and no cookie exists yet');
            return '';
        }
    }

    function advancedLotame() {
        var head = document.getElementsByTagName('head')[0],
            script = document.createElement('script');
        
        script.type = 'text/javascript';

        // onload doesnt work for IE8 so we have to do this crap
        if ($('html').hasClass('ie8')) {
            script.onreadystatechange = function () {
                var r = script.readyState;
                if (r === 'loaded' || r === 'complete') {
                    processAdvancedLotame();
                    script.onreadystatechange = null;
                }
            };
        }
        script.onload = function(){
            processAdvancedLotame();
        };

        if(_currLotameID){
            script.src = window.location.protocol + '//tags.crwdcntrl.net/c/' + _currLotameID + '/cc_af.js';
            head.appendChild(script);
        }
    }

    function processAdvancedLotame() {
        var lotaMeh = window['LOTCC_' + _currLotameID],
            cookieUser = rnn.modules.user.cookieData();

        if (lotaMeh) {
            lotaMeh.add('tp','APNA');
            if (cookieUser) {
                lotaMeh.add('genp', 'is_loggedin=true');
                if (cookieUser.uid !== '') {
                    lotaMeh.add('tpid', cookieUser.uid);
                    // delete the uid from the data so we can loop through all properties below
                    delete cookieUser.uid;
                }
                // loop through all properties and send them to lotame
                for (var property in cookieUser) {
                    if (cookieUser.hasOwnProperty(property)) {
                        if (cookieUser[property] !== '') {
                            lotaMeh.add('genp', property + '=' + cookieUser[property]);
                        }
                    }
                }
                if(!cookieUser.is_staff && !cookieUser.subscribed) {
                    lotaMeh.add('genp', 'is_account=true');
                } else {
                    lotaMeh.add('genp', 'is_account=false');
                }
            } else {
                lotaMeh.add('genp', 'is_loggedin=false');
                lotaMeh.add('genp', 'is_account=false');
            }
            lotaMeh.bcp();
        }
    }

    function lotamePane() {
        var audiences,
            audLength = 0,
            $panes = $('[data-lotame-slug]');

        if ($panes.length > 0) {
            audiences = genLotameAudiences();
            audiences = audiences.split(',');
            audLength = audiences.length;
            $.ajax({
                url: '/audiences-panes/',
                success: function(data) {
                    var content = '';
                    window.simon = data;
                    $panes.each(function () {
                        var $pane = $(this);
                        var slug = $pane.data('lotame-slug');
                        var paneAudienceFound = false;
                        // later on I bet people will want an order kind of thing.
                        // what if lotame shows that a user likes politics AND sports
                        // which one should we show them?
                        for (var i = 0; i < audLength; i++) {
                            var audienceId = audiences[i];
                            var paneSlug = slug + '-' + audienceId;
                            if (paneSlug in data) {
                                paneAudienceFound = true;
                                $pane.html(data[paneSlug]);
                                break;
                            }
                         }
                        // loading ui if need be
                        // $content.removeClass('hide');
                        // $pane.find('.pane-loading').remove();
                    })
                },
                error: function() {
                    // loading ui if need be
                    // $content.removeClass('hide');
                    // $pane.find('.pane-loading').remove();
                }
            });
        }
    }

    function initLotame() {
        // init
        advancedLotame();
        lotamePane();
    }

    rnn.modules.register('lotame', {
        init: initLotame,
        genLotameAudiences: genLotameAudiences
    });

})(jQuery);
